type CityStateAddress = {
  municipality?: string;
  region?: string;
};

export const getCityStateAddress = (address?: CityStateAddress): string => {
  if (!address) return "";

  return [address.municipality, address.region]
    .map((part) => part?.trim())
    .filter((part): part is string => Boolean(part))
    .join(", ");
};
